import { useQuery } from '@apollo/client'
import { get, set } from 'lodash-es'
import { useTranslation } from 'next-i18next'
import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import Select from '_app/components/Form/Select'
import { Maybe, Showroom, Showrooms } from '_app/graphql/generated/graphql'
import { GET_SHOWROOMS } from '_app/graphql/queries/content/GetShowrooms'
import { useCheckoutContext } from '../hooks'
import ShowroomInfo from './ShowroomInfo'
import {Text} from '@chakra-ui/react'

type ShowroomWithId = Omit<Showroom, 'id' | 'name'> & {
  id: string;
  name: string;
};
const foreignShowroomId = {
  Dusseldorf: '35',
  Munster: '37',
  Paris: '41',
}
const foreignIds = Object.values(foreignShowroomId)
const ShowroomsSelect = ({ cart }) => {
  const { t } = useTranslation()
  const { setSelectedShowroom, selectedShowroom } = useCheckoutContext()
  const { data } = useQuery<{ showrooms: Maybe<Showrooms> }>(GET_SHOWROOMS, {
    variables: {
      isPickupOnly: true
    }
  })
  const { getValues } = useFormContext()

  const showrooms = (data?.showrooms?.items || [])
    .filter(
      (showroom): showroom is ShowroomWithId =>
        !!showroom?.id && !!showroom.name && !foreignIds.includes(showroom.id)
    )
    .sort((a, b) => a.name.localeCompare(b.name))
  const showroomTarget = get(
    getValues(),
    'shipping_addresses[0].selected_shipping_method.showroom_target'
  )
  const selectedShowroomFind = showrooms.find(
    showroomItem => showroomItem.id === showroomTarget
  )
  useEffect(() => {
    if (selectedShowroomFind) {
      setSelectedShowroom(selectedShowroomFind)
    }
  }, [selectedShowroomFind, setSelectedShowroom, showroomTarget])
  return (
    <>
      <Select
        isRequired
        label={t('CHOOSE_BOUTIQUE')}
        name="shipping_addresses[0].selected_shipping_method.showroom_target"
        options={showrooms?.map(option => ({
          label: option.name,
          value: option.id,
        }))}
        id={selectedShowroom?.id}
      />
      {
        !selectedShowroom && (
              <Text
                  id="errorMessageInpost"
                  color="red"
                  fontSize="0.875rem"
                  fontWeight={400}
                  lineHeight="normal"
                  pt="8px"
              >
                Wybierz butik
              </Text>
          )
      }
      {selectedShowroom && <ShowroomInfo showroom={selectedShowroom} />}
    </>
  )
}

export default ShowroomsSelect
